import { makeStyles } from '@material-ui/core';

export const useInputFilterStyles  = makeStyles({
  root: {
    display                    : 'flex',
    '& div.MuiFormControl-root': {
      margin: 0,
    },
    '& :before': {
      border: 'none',
    },
  },
});
